import Vue from 'vue'
import wx from 'weixin-js-sdk';

const wxPlugin = {};
wxPlugin.install = function (Vue, options) {
    Vue.prototype.wx = wx;
};

Vue.use(wxPlugin);